export const devices = {
  tablet: 'tablet',
  mobile: 'mobile',
  desktop: 'desktop',
};

export const checkDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return devices.tablet;
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return devices.mobile;
  }
  return devices.desktop;
};
